module.exports = __webpack_public_path__ + "static/media/mustache.5b0ad3c7.png";